
<template>
    <div>
        <div class="app-title">
            <div>
                <h1>{{ $t("Production") }}</h1>
            </div>
        </div>
        <section class="app-content">
            <div class="card-columns">              
                <div class="card">
                    <h3 class="card-header text-center"><span class=" text-primary">{{$t('Mixing Managment')}}</span></h3>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                        <router-link to="/prd/mixingPlan" class="menu-title text-center"><span>{{$t('tlt.mixingPlan')}}</span></router-link></li>
                        <li class="list-group-item">
                        <router-link to="/prd/mixingResult" class="menu-title text-center"><span>{{$t('Mixing Formula')}}</span></router-link></li>
                        <li class="list-group-item">
                        <router-link to="/prd/mixingResult" class="menu-title text-center"><span>{{$t('Mixing Result')}}</span></router-link></li>
                    </ul>
                </div>
                <div class="card">
                    <h3 class="card-header text-center"><span class=" text-primary">{{$t('send Managment')}}</span></h3>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                        <router-link to="/prd/sendingPlanList" class="menu-title text-center"><span>{{$t('Send Plan')}}</span></router-link></li>
                        <li class="list-group-item">
                        <router-link to="/prd/sendingJob" class="menu-title text-center"><span>{{$t('Send Job')}}</span></router-link></li>
                        <li class="list-group-item">
                        <router-link to="/prd/sendingResult" class="menu-title text-center"><span>{{$t('Send Result')}}</span></router-link></li>
                    </ul>
                </div>
                <div class="card">
                    <h3 class="card-header text-center"><span class=" text-primary">{{$t('Loading Managment')}}</span></h3>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                        <router-link to="/prd/loadingPlan" class="menu-title text-center"><span>{{$t('Loading Plan')}}</span></router-link></li>
                        <li class="list-group-item">
                        <router-link to="/prd/loadingResult" class="menu-title text-center"><span>{{$t('Loading Result')}}</span></router-link></li>
                    </ul>
                </div>
            </div>
        </section>
    </div>    
</template>

<script>
export default {
  name: "home"
};
</script>
